import { Component, OnInit, Input } from '@angular/core';
import { ILayoutConfig } from '../../interfaces/layout-config';
import { Moment } from 'moment';

@Component({
  selector: 'app-default-header-layout',
  templateUrl: './default-header-layout.component.html',
  styleUrls: ['./default-header-layout.component.scss']
})
export class DefaultHeaderLayoutComponent implements OnInit {


  public config: ILayoutConfig;

  @Input()
  public set title(title: string) {
    this.config.title = title;
  }

  @Input()
  public set subtitle(subtitle: string) {
    this.config.subtitle = subtitle;
  }

  @Input()
  public set imageKey(imageKey: string) {
    this.config.imageKey = imageKey;
  }

  @Input()
  public set date(date: string) {
    this.config.date = date;
  }

  @Input()
  public set imageType(imageType: string) {
    this.config.imageType = imageType;
  }


  constructor() {
    this.config = {
      imageKey: '',
      imageType: '',
      title: '',
      subtitle: '',
    };
  }

  /**
   * Init app
   */
  public ngOnInit(): void {

  }

}
